import { Stack, Typography } from '@omnipresentgroup/design-system';

import { useAuth } from '../../hooks';
import type { AuthenticatedUser } from '../../types';

export type CanAccessFunction = (authUser: AuthenticatedUser) => boolean;

export const ProtectedRoute = ({
  canAccess,
  noAccessFallback,
  children,
}: {
  canAccess: CanAccessFunction;
  noAccessFallback?: JSX.Element;
  children: JSX.Element;
}) => {
  const { user: authUser } = useAuth();

  if (authUser && canAccess(authUser)) {
    return children;
  }

  return (
    noAccessFallback || (
      <Stack bg="primary" radius="m" p="32" border="subtle" align="center">
        <Typography as="p" size="16" hideParagraphSpacing>
          You do not have access to this page.
        </Typography>
      </Stack>
    )
  );
};
